import Cookies from 'cookies';
import { type GetServerSideProps } from 'next';
import Root, { type OwnProps as RootProps } from '~/Root';
import enableTestErrorPage from '~/server-props/enableTestErrorPage';
import getProps from '~/server-props/getProps';
import getRedirects from '~/server-props/getRedirects';
import getRequestContext from '~/server-props/getRequestContext';
import setDatadogUser from '~/server-props/setDatadogUser';

export default (props: RootProps) => <Root {...props} />;

export const getServerSideProps: GetServerSideProps<
  RootProps
> = async context => {
  // Sometimes *.js.map files are sent to SRP. Throw them out ASAP.
  if (context.resolvedUrl.includes('.js.map')) {
    return { notFound: true };
  }

  const serverCookies = new Cookies(context.req, context.res);
  const requestContext = getRequestContext(context);

  const redirect = getRedirects(context);

  if (redirect) {
    return { redirect };
  }

  enableTestErrorPage(context);
  setDatadogUser(context, serverCookies);

  return getProps(context, requestContext, serverCookies);
};
